import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IContact } from "../../utils/types/models";

export default createEntityReducer<IContact>(Endpoint.Contacts);
